import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Row,
  Col,
} from 'reactstrap';
import Select from 'react-select';
import moment from 'moment';
import * as REGEX from '../../../constants/regex';

class WasteReadingAdminForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readingDate: moment(props.reading.timestamp).format('YYYY-MM-DD'),
      readingTime: moment(props.reading.timestamp).format('HH:mm'),
      selectedWeatherType: props.reading.weather,
      reading: props.reading,
      saving: false,
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reading) {
      if (this.props.reading.id !== nextProps.reading.id) {
        this.setState({
          reading: Object.assign({}, nextProps.reading),
        });
      }
    }
  }

  onWeatherChange = (selectedOption) => {
    let wasteReading = Object.assign({}, this.state.reading);
    wasteReading.weather = selectedOption.value;
    this.setState({
      selectedWeatherType: selectedOption.value,
      reading: wasteReading,
    });
  };

  formIsValid = () => {
    const wasteReading = this.state.reading;
    let errors = {};
    let isValid = true;

    this.setState({ errors: errors });
    return isValid;
  };

  saveReading = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    let newReading = Object.assign({}, this.state.reading);
    const formattedTime = moment(
      `${this.state.readingDate} ${this.state.readingTime}`
    ).format('YYYY-MM-DDTHH:mm:ss');
    newReading.timestamp = formattedTime;
    delete newReading.readingDate;
    delete newReading.readingTime;
    this.props.onSave(newReading);
  };

  deleteReading = (event) => {
    event.preventDefault();
    this.props.onDelete(this.state.reading);
  };

  updateReadingState = (event) => {
    const field = event.target.id;
    let reading = Object.assign({}, this.state.reading);
    reading[field] = event.target.value;
    this.setState({ reading: reading });
  };

  render() {
    const { readingDate, readingTime } = this.state;
    const { errors, saving, reading, selectedWeatherType } = this.state;
    return (
      <Form>
        <Row>
          <FormGroup className="mr-4 mb-md-2">
            <Label for="id">ID</Label>
            <Input
              type="text"
              name="id"
              id="id"
              value={reading.id}
              readOnly="true"
            />
          </FormGroup>
        </Row>

        <Row>
          <Col xs={12}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="masterMeter" className="mr-2">
                Master Meter
              </Label>
              <Input
                type="number"
                id="masterReading"
                name="masterReading"
                value={reading.masterReading}
                onChange={this.updateReadingState}
              />
              {errors.masterReading && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.masterReading}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <h5 className="mt-2">Influent</h5>
        <Row>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="phIn" className="mr-2">
                pH
              </Label>
              <Input
                type="number"
                id="phIn"
                value={reading.phIn}
                onChange={this.updateReadingState}
              />
              {errors.phIn && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.phIn}
                </Alert>
              )}
            </FormGroup>
          </Col>

          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="tempIn" className="mr-2">
                Temperature
              </Label>
              <Input
                type="number"
                id="tempIn"
                value={reading.tempIn}
                onChange={this.updateReadingState}
              />
              {errors.tempIn && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.tempIn}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <h5 className="mt-2">Effluent</h5>

        <Row>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="phOut" className="mr-2">
                pH
              </Label>
              <Input
                type="number"
                id="phOut"
                value={reading.phOut}
                onChange={this.updateReadingState}
              />
              {errors.phOut && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.phOut}
                </Alert>
              )}
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="bioOxyDemand" className="mr-2">
                Biological Oxygen Demand
              </Label>
              <Input
                type="number"
                id="bioOxyDemand"
                value={reading.bioOxyDemand}
                onChange={this.updateReadingState}
              />
              {errors.bioOxyDemand && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.bioOxyDemand}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="chlorineResidual" className="mr-2">
                Chlorine Residual
              </Label>
              <Input
                type="number"
                id="chlorineResidual"
                value={reading.chlorineResidual}
                onChange={this.updateReadingState}
              />
              {errors.chlorineResidual && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.chlorineResidual}
                </Alert>
              )}
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="phosphorous" className="mr-2">
                Phosphorous
              </Label>
              <Input
                type="number"
                id="phosphorous"
                value={reading.phosphorous}
                onChange={this.updateReadingState}
              />
              {errors.phosphorous && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.phosphorous}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="dissolvedOxygen" className="mr-2">
                Dissolved Oxygen
              </Label>
              <Input
                type="number"
                id="dissolvedOxygen"
                value={reading.dissolvedOxygen}
                onChange={this.updateReadingState}
              />
              {errors.dissolvedOxygen && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.dissolvedOxygen}
                </Alert>
              )}
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="dechlorination" className="mr-2">
                De-chlorination
              </Label>
              <Input
                type="number"
                id="dechlorination"
                value={reading.dechlorination}
                onChange={this.updateReadingState}
              />
              {errors.dechlorination && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.dechlorination}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="sludgeLevel" className="mr-2">
                Sludge Level
              </Label>
              <Input
                type="number"
                id="sludgeLevel"
                value={reading.sludgeLevel}
                onChange={this.updateReadingState}
              />
              {errors.sludgeLevel && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.sludgeLevel}
                </Alert>
              )}
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="tempOut" className="mr-2">
                Temp Out
              </Label>
              <Input
                type="number"
                id="tempOut"
                value={reading.tempOut}
                onChange={this.updateReadingState}
              />
              {errors.tempOut && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.tempOut}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="precipitation" className="mr-2">
                Precipitation
              </Label>
              <Input
                type="number"
                id="precipitation"
                value={reading.precipitation}
                onChange={this.updateReadingState}
              />
              {errors.precipitation && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.precipitation}
                </Alert>
              )}
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <Label for="weather">Weather Conditions</Label>
              <Select
                name="weather"
                id="weather"
                value={selectedWeatherType}
                onChange={this.onWeatherChange}
                options={[
                  { value: 'C', label: 'Clear' },
                  { value: 'PC', label: 'Partly Cloudy' },
                  { value: 'OC', label: 'Overcast' },
                  { value: 'R', label: 'Rain' },
                ]}
                className="mr-2"
              />
              {errors.weather && (
                <Alert className="my-2 p-2" color={'danger'}>
                  {errors.weather}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <FormGroup className="mr-4 mb-md-2">
              <Label for="comments" className="mr-2">
                Comments
              </Label>
              <Input
                type="textarea"
                id="comments"
                value={reading.comments}
                onChange={this.updateReadingState}
              />
              {errors.comments && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.comments}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <FormGroup>
          <Label for="readingDate">Reading Date</Label>
          <Input
            type="date"
            name="readingDate"
            id="readingDate"
            value={readingDate}
            onChange={(event) => {
              this.setState({
                readingDate: event.target.value,
              });
            }}
          />
          {errors.readingDate && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.readingDate}
            </Alert>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="readingTime">Reading Time</Label>
          <Input
            type="time"
            name="readingTime"
            id="readingTime"
            value={readingTime}
            onChange={(event) => {
              this.setState({
                readingTime: event.target.value,
              });
            }}
          />
          {errors.readingTime && (
            <Alert className="mt-2 p-2" color={'danger'}>
              {errors.readingTime}
            </Alert>
          )}
        </FormGroup>

        <FormGroup className="mb-4">
          <Button
            color="secondary"
            type="submit"
            disabled={saving}
            onClick={this.deleteReading}
            style={{ float: 'left' }}
          >
            Delete
          </Button>
          <Button
            color="primary"
            type="submit"
            onClick={this.saveReading}
            style={{ float: 'right' }}
          >
            {saving ? 'Saving' : 'Save'}
          </Button>
        </FormGroup>
      </Form>
    );
  }
}

WasteReadingAdminForm.propTypes = {
  reading: PropTypes.object.isRequired,
};

export default WasteReadingAdminForm;



// WEBPACK FOOTER //
// ./src/components/reading/waste/WasteReadingAdminForm.js